import React, { memo } from 'react';
import Context from './index';
import {
  useGetFeaturedCourses,
  useGetFeaturedSchools,
} from '../effects/useGetFeatured';

function Provider({ children }) {
  const {
    selected: selectedCourse,
    handleSelect: handleSelectCourse,
    data: courses,
  } = useGetFeaturedCourses();
  const {
    selected: selectedSchool,
    handleSelect: handleSelectSchool,
    data: schools,
  } = useGetFeaturedSchools();

  const initialValue = {
    selectedCourse,
    handleSelectCourse,
    courses,
    schools,
    selectedSchool,
    handleSelectSchool,
  };

  return <Context.Provider value={initialValue}>{children}</Context.Provider>;
}

export default memo(Provider);
